export default __webpack_public_path__ + "static/media/FrontCover.22ca9025.txt";